module.exports = __webpack_public_path__ + "img/logo-list-1.32ad7c04.png";